import {
  ADVISOR_CLIENTS_RECEIVED,
  ADVISOR_CLIENTS_UNLOADED
} from './types'

export default function clients(state = [], action = {}){
  switch (action.type) {
    case ADVISOR_CLIENTS_RECEIVED:
      return action.data 
    case ADVISOR_CLIENTS_UNLOADED:
      return []
    default:
      return state;
  }
}